import type { PartDefinition } from "@rogue/rackbuilder"
import { getIndyCarriageOffset } from "./indyOffsets"
import { buildFrontCable } from "./indyWeightStack"
import { IndyContext, is80Height } from "./indyHelpers"
import { getRackModel } from "@/js/pages/product/rackbuilder/modelPaths"

// MARK: Branding
export function buildCarriageBrandingPlate(context: IndyContext): PartDefinition {
  const { config, left } = context
  
  const mesh = is80Height(config)
    ? getRackModel('INDY_80', 'carriage branding plate 80')
    : getRackModel('INDY', 'carriage branding plate')

  return {
    mesh,
    slots       : {},
    anchor      : left ? '' : 'front',
    offset      : left ? {} : { z: 0.1 },
    adjustments : left ? [] : [{ type: 'flip', axis: 'Z' }],
  }
}

// MARK: Carriage Assembly
export function buildIndyCarriage(context: IndyContext, trolleyClip: PartDefinition): PartDefinition {
  const { config, materials } = context
  
  const carriageMesh = is80Height(config)
    ? getRackModel('INDY_80', 'carriage 80')
    : getRackModel('INDY', 'carriage')
  
  const carriage: PartDefinition = {
    mesh  : carriageMesh,
    slots : {
      cable    : buildFrontCable(context),
      branding : buildCarriageBrandingPlate(context),
    },
    materials,
    offset: getIndyCarriageOffset(config),
  }
  
  if (config.trolleySelection) {
    carriage.slots.trolley = trolleyClip
  }
  
  return carriage
}